import { z } from 'zod';
/** Exports: `?format=xlsx|pdf` plus the list or report filters. */
export const EXPORT_FORMATS = ['xlsx', 'pdf'];
export const exportFormatSchema = z.enum(EXPORT_FORMATS);
//# sourceMappingURL=export-format.js.map